module.exports = __webpack_public_path__ + "static/media/durian.aaa7ea83.webp";